module.exports = __webpack_public_path__ + "static/media/Hiphop.63043bde.mp3";